import { render, staticRenderFns } from "./DatasourceTabLineage.vue?vue&type=template&id=7bd6083b&lang=pug"
import script from "./DatasourceTabLineage.vue?vue&type=script&lang=js"
export * from "./DatasourceTabLineage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bd6083b')) {
      api.createRecord('7bd6083b', component.options)
    } else {
      api.reload('7bd6083b', component.options)
    }
    module.hot.accept("./DatasourceTabLineage.vue?vue&type=template&id=7bd6083b&lang=pug", function () {
      api.rerender('7bd6083b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/tableau/components/datasource/DatasourceTabLineage.vue"
export default component.exports